var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(" This application is built with Vue.js 2 & secured with Auth0. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }